/* eslint-disable no-alert */
import boxx from '@baidu/boxx';
import bridge from './bridge';
import {HOST_CONFIG} from './constant';
import {ENV} from './env';

export function getCurrentHost() {
    const ENV = location.host;
    if (ENV.includes('bce.baidu')) {
        // 线上地址
        return HOST_CONFIG.online;
    } else if (ENV.includes('localhost')) {
        // 本地开发地址
        return HOST_CONFIG.localhost;
    } else {
        // 沙盒开发地址
        return location.origin;
    }
}

// iframe与native通信
export function invokeByIframe(url: string) {
    let elem = document.createElement('iframe') as any;
    const body = document.body || document.getElementsByTagName('body')[0];
    elem.style.display = 'none';
    elem.src = url;
    body.appendChild(elem);
    setTimeout(() => {
        body.removeChild(elem);
        elem = null;
    }, 0);
}

/**
 * 手百native交互文档
 * https://console.cloud.baidu-int.com/devops/icode/repos/baidu/search-fe/boxx/tree/master
 * https://console.cloud.baidu-int.com/devops/icode/repos/baidu/search-fe/boxx/tree/master
 * 如流群：4627460
 */
export function baiduAppBack() {
    const canIUseClose = boxx.canIUse('search.closeWindow');
    if (canIUseClose) {
        boxx.search.closeWindow({});
    }
}

export function baiduyunAppBack() {
    bridge.close();
}

export function browserBack() {
    // 刷脸H5一般页面深度为3
    const pageDep = 3;
    const len = history.length + pageDep || 1;
    if (ENV.android()) {
        history.go(-len);
    } else if (ENV.ios()) {
        // history.go ios端无法实现
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < len; i++) {
            history.back();
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (window && window.close && typeof window.close === 'function') {
            window.close();
        }
    }
}

export async function backToNative() {
    if (ENV.baidu()) {
        baiduAppBack();
    } else if (ENV.baiduyun()) {
        baiduyunAppBack();
    } else {
        browserBack();
    }
}
